import { type Column } from 'exceljs';
import { CustomColumn } from '..';

export const GRID_COLUMN_DEFAULT_STYLE: Partial<Column['style']> = {
  font: {
    size: 12,
  },
  alignment: {
    vertical: 'middle',
    wrapText: true,
  },
};

export const MODERN_GRID_DEPTH_COLUMN: Partial<Column> = {
  header: '',
  key: 'level',
  width: 10,
  style: GRID_COLUMN_DEFAULT_STYLE,
};

export const BASE_GRID_DEPTH_COLUMN: CustomColumn = {
  field: 'level',
  caption: '',
  width: 60,
};
